import { Grid, Tab, Tabs, styled } from "@mui/material";

import React from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function WalletTypeTabs() {
  const tradeInitial = useSelector((state) => state.trade.tradeInitial?.data);

  const [searchParams, setSearchParams] = useSearchParams();
  const walletTypeId = +searchParams.get("walletTypeId") || 1;

  const handleChange = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);
    setSearchParams({ ...allSearchParams, walletTypeId: newValue });
  };

  return (
    <Grid item xs={12}>
      <TabsStyle value={walletTypeId} onChange={handleChange}>
        {tradeInitial?.lisWalletType?.map((wallet, index) => (
          <Tab label={wallet?.name} value={wallet?.id} key={index} />
        ))}
      </TabsStyle>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  marginBottom: theme.spacing(3),

  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
    maxWidth: "300px",
    margin: "auto",
  },
}));

export default WalletTypeTabs;
